export default __webpack_public_path__ + "static/media/things-logo.07369284.svg";